import { booleanAttribute, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';

import { Subscription } from 'rxjs';

import { transform } from 'lodash';

import { MeService, UserGroupEnumText, UserResponseDto, UserRoleResponseDto } from '@api';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';

import { GlobalDataService } from '@core-service';
import { AuthService } from '@core/auth/services/auth.service';
import { DefaultModule, PrimeModule } from '@module';

import { CoreStorageService, CoreTranslateService, LayoutsService, MenuItem } from 'pn-core-code';

import { AvatarModule } from 'primeng/avatar';
import { MenuModule } from 'primeng/menu';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [DefaultModule, PrimeModule, AvatarModule, MenuModule],
  providers: [AuthService],
  templateUrl: './app-topbar.component.html',
  styleUrl: './app-topbar.component.scss'
})
export class AppTopbarComponent implements OnInit, OnDestroy {

  @Input({ transform: booleanAttribute }) hasSidebar: boolean;

  items: MenuItem[] | undefined;

  isShowSidebarSub: Subscription;
  isShowSidebar: boolean = false;

  userProfile: any;
  canGoToLandingPage: any;

  userData: UserResponseDto = {} as UserResponseDto;
  userRoles: UserRoleResponseDto = {} as UserRoleResponseDto;

  userGroupEnumTex = UserGroupEnumText;
  focusUserGroupSub: Subscription;

  constructor(
    private layoutsService: LayoutsService,
    private authService: AuthService,
    private translateService: TranslateService,
    private coreTranslate: CoreTranslateService,
    private global: GlobalDataService,
    private router: Router,
    private localize: LocalizeRouterService,
    private storage: CoreStorageService,
    private meService: MeService,
    private route: ActivatedRoute,
  ) {
    this.isShowSidebarSub = this.layoutsService.isShowSidebar.subscribe(v => {
      this.isShowSidebar = v;
    })
    this.focusUserGroupSub = this.global.focusUserGroupSubject.subscribe(data => {
      if (!data) {
        this.global.getFocusUserGroup();
      } else {

        const tempFocusUserGroup = this.storage.getItem('focus_user_group');
        if (tempFocusUserGroup) {
          const data = JSON.parse(tempFocusUserGroup);
          this.userRoles = data
        } else {
          const userGroupData = data;
          this.userRoles = userGroupData;
        }
      }
    })
  }

  ngOnInit() {
    this.getUserProfile();
    this.items = [
      { label: this.translateService.instant('changeLanguage'), icon: 'pi pi-globe', command: () => { this.changeLanguage(); }, },
      { label: 'จัดการบัญชี', icon: 'pi pi-user', command: () => { this.router.navigate([this.localize.translateRoute(`/manage-accounts`)]); }, },
      { label: 'Logout', icon: 'pi pi-sign-out', command: () => { this.authService.logout(); } }
    ];
  }

  getUserProfile() {
    this.meService.meGet$()
      .subscribe(data => {
        try {
          this.userData = data;
        } catch (error) {
          console.log('error setFocusCustomer', error);
        }

      });
  }

  ngOnDestroy(): void {
    this.isShowSidebarSub && this.isShowSidebarSub.unsubscribe();
    this.focusUserGroupSub && this.focusUserGroupSub.unsubscribe();
  }

  onToggleSidebar() {
    this.layoutsService.toggleSidebar();
  }

  changeLanguage() {
    let currentLang = this.translateService.currentLang;
    this.coreTranslate.switchLanguage((!currentLang || currentLang === 'th') ? 'en' : 'th');
  }

  goToLandingPage() {
    console.log('goToLandingPage', this.userProfile, this.canGoToLandingPage);
    this.storage.removeItem('focus_user_group');
    this.router.navigate([this.localize.translateRoute('/welcome')], { replaceUrl: true });
    // if (this.canGoToLandingPage) {
    //   this.router.navigate([this.localize.translateRoute('/welcome')]);
    // }
  }

}